module.exports = __webpack_public_path__ + "img/icon-03.ec80de57.svg";